export default __webpack_public_path__ + "static/media/KOD0100-min.076e040e.webp";